import { useState } from 'react';

import Tooltip from 'components/onClickTooltip';
import i18n from 'i18n/config';
import {
  QuestionMarkInCircleFilledIcon,
  QuestionMarkInCircleIcon,
} from 'styles/assets/icons';

import styles from './indianWallet.module.scss';

const popoverContent = i18n.t('headerFooter:header.wallet.conversionPopOver');

const ConversionPopover = () => {
  const [IsTooltipEnableForConversion, setIsTooltipEnableForConversion] = useState(false);
  const getTooltipStatus = (status: boolean) => setIsTooltipEnableForConversion(status);
  return (
    <Tooltip
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      getTooltipStatus={getTooltipStatus}
      isTopLevelContainer={false}
      title={
        IsTooltipEnableForConversion ? (
          <QuestionMarkInCircleFilledIcon width={16} height={16} />
        ) : (
          <QuestionMarkInCircleIcon />
        )
      }
      titleClass={styles.tooltipTitle}
      body={popoverContent}
      data-testid="conversion-popover"
    />
  );
};

export default ConversionPopover;
